<template>
  <div>
    <div
      class="flex cursor-pointer items-center justify-between py-4"
      :class="{ 'cursor-default': noExpand }"
      @click="!noExpand && toggle()"
    >
      <h3 class="text-xl font-semibold">
        {{ title }}
      </h3>
      <div v-if="!noExpand" class="text-white">
        <IconPlus v-if="!isExpanded" class="size-4" />
        <IconMinus v-else class="size-4" />
      </div>
    </div>
    <div
      class="overflow-hidden transition-all duration-300 ease-in-out"
      :class="{
        'max-h-[500px]': isExpanded || noExpand,
        'max-h-0': !isExpanded && !noExpand,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconPlus from '~/components/icons/IconPlus.vue'
import IconMinus from '~/components/icons/IconMinus.vue'

defineProps<{
  title: string
  noExpand?: boolean
}>()

const isExpanded = ref(false)

const toggle = () => {
  isExpanded.value = !isExpanded.value
}

// Expose the reset method to parent components
defineExpose({
  reset: () => {
    isExpanded.value = false
  },
})
</script>

<script lang="ts">
export default {
  name: 'Accordion',
}
</script>
